/**
 * Fires only once in a timeout period. This version fires only on falling edge.
 * @param {Function} callback funtion be called
 * @param {number} [timeout] timeout in milliseconds, default 300 ms
 * @returns {Function} wrapper function
 */
export function debounce( callback:Function, timeout:number = 300 ):Function {

  let timer:ReturnType<typeof setTimeout>;

  function wrapper(...args: any[]) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      callback.apply( wrapper, args );
    }, timeout);
  }

  return wrapper;
}

/**
 * Selector is used to format CSS-selector
 */
export class Selector {
  private rawSeletor:string;

  /**
   * @constructor
   * @param {string} selector raw selector
   */
  constructor( selector:string ) {
    this.rawSeletor = selector;
  }

  /**
   * Return selector as it is given
   */
  get selector():string {
    return this.rawSeletor;
  }

  /**
   * Removes dot from class name
   */
  get className():string {
    return this.rawSeletor.replace('.','');
  }
}
